import { Injectable } from '@kaokei/use-vue-service';
import { DaoService } from './dao.service';

import { UserExam, UserExamList } from '@/types';

@Injectable()
export class UserExamService {
  public DEFAULT_PAGE_SIZE = 20;
  public pageNum = 1;
  public pageSize = this.DEFAULT_PAGE_SIZE;
  public total = -1;

  public userExamList: UserExamList = [];

  public userExamId!: number;

  public userExam!: UserExam;

  public plainText!: string;

  public interTimer!: any;

  constructor(public daoService: DaoService) {}

  public setUserExamId(num: number) {
    this.userExamId = num;
  }

  public setPageNum(num: number) {
    this.pageNum = num;
  }

  public setPageSize(size: number) {
    this.pageSize = size;
  }

  public getPlainText(userId: number, contestInfoId: number, type: string) {
    return this.daoService
      .getUserPlainText(userId, contestInfoId)
      .then(result => {
        if (type === 'phone') {
          this.plainText = result?.mobile;
        } else if (type === 'idcode') {
          this.plainText = result?.carNo;
        }
      });
  }

  public search(autoRefresh?: boolean) {
    if (!autoRefresh) {
      window.scrollTo(0, 0);
    }
    return this.daoService
      .getUserExamList(this.pageNum, this.pageSize)
      .then(res => {
        this.userExamList = res.list || [];
        this.total = res.total;
        clearInterval(this.interTimer);
        /**
         * status 状态
         * NOTHING(0, "没有任何按钮信息")
         * EXAMINATION(1, "开始考试")
         * DEFENCE(2, "开始答辩")
         * WAITING(3, "即将考试")
         * BEFORE_CHECK(4, "考试准备")
         * 开启考前检录的status状态
         * 未开启考前检录的status状态
         */
        this.interTimer = setInterval(() => {
          const waitStartList = this.userExamList.filter(item =>
            [3, 4].includes(item.status)
          );
          if (!waitStartList.length) {
            clearInterval(this.interTimer);
            return;
          }
          waitStartList.forEach((item: any) => {
            const { userSupportCheck } = item;
            const needCheckDevice = Boolean(
              userSupportCheck?.deviceCheckConfig
            );
            if (
              needCheckDevice &&
              item.startTime < Date.now() + 1000 * 60 * 60
            ) {
              item.status = 4;
            } else {
              if (item.startTime < Date.now()) {
                item.status = 1;
              }
            }
          });
        }, 2000);
        /**
        // 找到最近的即将开始考试的赛事
        const firstExam = [...res.list]
          .sort((a, b) => a.startTime - b.startTime)
          .find(item => item.status === 3);
        if (firstExam) {
          this.interTimer = setInterval(() => {
            // 列表数据中 存在待考试的数据，间隔两秒执行，请求服务器次数过多
            // 优化逻辑：跟本地时间对比，本地时间已经到达开始时间才重新请求
            if (firstExam.startTime < Date.now()) {
              // 达到本地时间后，随机延迟0～4s执行请求
              const randomSecound = Math.floor(Math.random() * 5) * 1000;
              setTimeout(() => {
                this.search(true);
              }, randomSecound);
              clearInterval(this.interTimer);
            }
          }, 2000);
        }
         */
      })
      .catch(() => {
        clearInterval(this.interTimer);
      });
  }

  public clearTimer() {
    clearInterval(this.interTimer);
  }

  public resetSearch() {
    this.setPageNum(1);
    this.setPageSize(this.DEFAULT_PAGE_SIZE);
    this.search();
  }

  public getUserExamDetail() {
    return this.daoService.getUserExamDetail(this.userExamId).then(res => {
      if (res.contestScheduleId) {
        res.areaIds = [res.provinceId, res.cityId, res.districtId];
      }
      this.userExam = res;
    });
  }
}
